import React, { useState } from "react";
import 'react-csv-importer/dist/index.css';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from "@mui/icons-material/Error";
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { selectDismissLeadPerm } from "../../../../../slices/userActionsPermissionsSlice";
import { Button } from "../../../../../StyledComponents";
import { useDismissLeadMutation, useReloadRefinanceQuarterlyBreakdownMutation, useReloadRenegotiationQuarterlyBreakdownMutation, useResolveAllDiscrepanciesMutation } from "../../../../../slices/api/apiSlice";
import WorkflowPanel, { DecisionCard, DecisionCopy, DecisionTitle, WorkflowBody, WorkflowFooter, WorkflowHeader, WorkflowScroll } from "./WorkflowPanel";

const DismissLead = ({ handleCloseModal, userFullName, teamId, leadData, userId, dashPerspective }) => {
  const theme = useTheme();

  const dismissLeadPerm = useSelector(selectDismissLeadPerm)

  const [isFetching, setIsFetching] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isError, setIsError] = useState(false)

  const [dismissLead] = useDismissLeadMutation()
  const [resolveAllDiscrepancies] = useResolveAllDiscrepanciesMutation()
  const [realoadRefinanceQuarterBreakdown] = useReloadRefinanceQuarterlyBreakdownMutation()
  const [reloadRenegotiationQuarterlyBreakdown] = useReloadRenegotiationQuarterlyBreakdownMutation()

  const handleDismissLead = async () => {
    setIsFetching(true)
    // let resolveResp = await resolveAllDiscrepancies({
    //   userId: userId,
    //   userFullName: userFullName,
    //   teamId: teamId,
    //   mortgageId: leadData.belongsToMortgage,
    //   mission: 'dismissInvestigation'
    // })
    // if (resolveResp.error) {
    //   setIsError(true)
    // } else {
      let resp = await dismissLead({
        leadId: leadData._id,
        userId: userId,
        dashPerspective: dashPerspective,
        teamId: teamId,
        mortgageId: leadData.belongsToMortgage,
        userFullName: userFullName,
      })
      if (!resp.error && resp.data.message.includes('successful')) {
        setIsSuccess(true)
        if (leadData.targetOutcome.toUpperCase() === 'RENEGOTIATION') {
          await reloadRenegotiationQuarterlyBreakdown({
            userId: userId,
            teamId: teamId,
            leadTier: leadData.tier,
            actionTaken: 'dismissed',
            closureType: leadData.targetOutcome,
          })
        } else {
          await realoadRefinanceQuarterBreakdown({
            userId: userId,
            teamId: teamId,
            leadTier: leadData.tier,
            actionTaken: 'dismissed',
            closureType: leadData.targetOutcome,
          })
        }
      } else {
        setIsError(true)
      }
    // }
    setIsFetching(false)
  }

  return (
    <WorkflowPanel>
      {isSuccess ?
        <WorkflowHeader tone="success" title="Success" icon={<CheckIcon />} />
      : isError ?
        <WorkflowHeader tone="error" title="Failed... please try again. Reach out to support@lancastersweep.com if the problem persists." icon={<ErrorIcon />} />
      :
        <WorkflowHeader tone="danger" title="Dismiss Lead" subtitle="Dismissal is a destructive workflow transition." />
      }

      <WorkflowBody>
        <WorkflowScroll className="centered">
          <DecisionCard tone="danger">
            <DecisionTitle>{isSuccess ? "Investigation dismissed" : "Confirm dismissal"}</DecisionTitle>
            <DecisionCopy>
              {isSuccess ?
                `Thie investigation has been dismissed.`
              :
                <>
                  Dismissing the investigation will resolve all discrepancies to match public records.<br/>
                  Record any summary notes to serve as a future reference in the Dismissal Report.
                </>
              }
            </DecisionCopy>
          </DecisionCard>
        </WorkflowScroll>

        <WorkflowFooter>
          {isSuccess ?
            <Button className="neutral" onClick={() => handleCloseModal()}>Close</Button>
          : isFetching ?
            <Button className="dismissLoading">
              <CircularProgress
                sx={{ color: `${theme.palette.common.white}` }}
                size={18}
              />
            </Button>
          :
            <Button className={dismissLeadPerm ? "dismiss" : "dismissDisabled"} onClick={dismissLeadPerm ? () => handleDismissLead() : null}>Continue</Button>
          }
        </WorkflowFooter>
      </WorkflowBody>
    </WorkflowPanel>
  )
}

export default DismissLead;
